import React from 'react';
import { AulaPlugin } from '../plugins';
import { Unsupported } from '../../components/Unsupported/Unsupported';
import { unsupportedType } from './UnsupportedElement';

export const unsupported: AulaPlugin = (editableProps, editor) => {
  const { isVoid } = editor;

  editor.isVoid = (el) => el.type === unsupportedType || isVoid(el);

  return {
    ...editableProps,
    renderElement: (props) => {
      const { element, attributes, children } = props;

      if (element.type !== unsupportedType && editableProps.renderElement) {
        return editableProps.renderElement(props);
      }

      return (
        <div {...attributes}>
          <div contentEditable={false}>
            <Unsupported element={element as any} />
          </div>
          {children}
        </div>
      );
    },
  };
};
